import { query_order_used_record_list } from '@/api/mjstore-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'order_code',
      label: '耗单号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写耗单号',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目名称',
      disabled: false,
      placeholder: '请选择项目名称',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
    {
      type: 'remotemodal',
      name: 'customer_id',
      label: '会员姓名',
      disabled: false,
      placeholder: '请选择会员姓名',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-customer',
    },
    {
      type: 'remotemodal',
      name: 'staff_id',
      label: '执行人',
      disabled: false,
      placeholder: '请选择执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'remoteselect',
      name: 'card_record_id',
      label: '会员购买的卡',
      disabled: false,
      placeholder: '请选择会员购买的卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-cardrecord',
    },
    {
      type: 'input',
      name: 'project_set_id',
      label: 'project_set_id',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写project_set_id',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '执行门店',
      disabled: false,
      placeholder: '请选择执行门店',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'datepicker',
      name: 'date',
      label: '耗单日期',
      disabled: false,
      allowClear: true,
      inputType: 'number',
      defaultValue: '',
      format: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      showTime: true,
      placeholder: '请选择耗单日期',
    },
    {
      type: 'remotemodal',
      name: 'delete_staff_id',
      label: '作废执行人',
      disabled: false,
      placeholder: '请选择作废执行人',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-staff',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    order_code: null,
    project_id: null,
    customer_id: null,
    staff_id: null,
    card_id: null,
    card_record_id: null,
    project_set_id: null,
    shop_id: null,
    bed_id: null,
    date: null,
    is_delete: null,
    delete_staff_id: null,
  }),
};
const search_options = {
  is_delete: [
    { value: None, name: '全部' },
    { value: True, name: '已作废' },
    { value: False, name: '未作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: 'ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '耗单号',
    width: 150,
    dataIndex: 'order_code',
    fixed: false,
    checked: true,
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'customer_id',
    fixed: false,
    checked: false,
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'customer__code',
    fixed: false,
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'customer__name',
    fixed: false,
    checked: true,
  },
  {
    title: '卡ID',
    width: 150,
    dataIndex: 'card_id',
    fixed: false,
    checked: false,
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'card__name',
    fixed: false,
    checked: true,
  },
  {
    title: '会员购买的单ID',
    width: 150,
    dataIndex: 'order_record_id',
    fixed: false,
    checked: false,
  },
  {
    title: '下单号',
    width: 150,
    dataIndex: 'order_record__order_code',
    fixed: false,
    checked: true,
  },
  {
    title: '购卡记录ID',
    width: 150,
    dataIndex: 'card_record_id',
    fixed: false,
    checked: false,
  },
  {
    title: '卡号',
    width: 150,
    dataIndex: 'card_record__order_code',
    fixed: false,
    checked: true,
  },
  {
    title: '套餐购买记录ID',
    width: 150,
    dataIndex: 'set_record_id',
    fixed: false,
    checked: false,
  },
  {
    title: '套餐流水号',
    width: 150,
    dataIndex: 'set_record__order_code',
    fixed: false,
    checked: true,
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'project_id',
    fixed: false,
    checked: false,
  },
  {
    title: '项目名称',
    width: 150,
    dataIndex: 'project__name',
    fixed: false,
    checked: true,
  },
  {
    title: '项目单价',
    width: 150,
    dataIndex: 'project_price',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '耗单次数',
    width: 150,
    dataIndex: 'num',
    fixed: false,
    checked: true,
  },
  {
    title: '退单数',
    width: 150,
    dataIndex: 'cancel_num',
    fixed: false,
    checked: true,
  },
  {
    title: '总价',
    width: 150,
    dataIndex: 'price',
    fixed: false,
    checked: true,
  },
  {
    title: '换单价差',
    width: 150,
    dataIndex: 'diff_price',
    fixed: false,
    checked: true,
  },
  {
    title: '充值使用金额',
    width: 150,
    dataIndex: 'czje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '返利使用金额',
    width: 150,
    dataIndex: 'flje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '直接返利',
    width: 150,
    dataIndex: 'zjfl',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '赠券使用金额',
    width: 150,
    dataIndex: 'zjje',
    fixed: false,
    checked: true,
    slots: { customRender: 'round_price' },
  },
  {
    title: '耗单日期',
    width: 150,
    dataIndex: 'date',
    fixed: false,
    checked: true,
  },
  {
    title: '员工编码',
    width: 150,
    dataIndex: 'staff__code',
    fixed: false,
    checked: true,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '床位',
    width: 150,
    dataIndex: 'bed_id',
    fixed: false,
    checked: false,
  },
  {
    title: '床位编号',
    width: 150,
    dataIndex: 'bed__name',
    fixed: false,
    checked: false,
  },
  {
    title: '床位开始使用时间',
    width: 150,
    dataIndex: 'bed_start_time',
    fixed: false,
    checked: false,
  },
  {
    title: '床位结束使用时间',
    width: 150,
    dataIndex: 'bed_end_time',
    fixed: false,
    checked: false,
  },
  {
    title: '执行人ID',
    width: 150,
    dataIndex: 'staff_id',
    fixed: false,
    checked: false,
  },
  {
    title: '备注',
    width: 150,
    dataIndex: 'mark',
    fixed: false,
    checked: false,
  },
  {
    title: '门店ID',
    width: 150,
    dataIndex: 'shop_id',
    fixed: false,
    checked: false,
  },
  {
    title: '门店名称',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '是否作废',
    width: 150,
    dataIndex: 'is_delete',
    fixed: false,
    checked: true,
  },
  {
    title: '作废时间',
    width: 150,
    dataIndex: 'delete_time',
    fixed: false,
    checked: true,
  },
  {
    title: '作废人ID',
    width: 150,
    dataIndex: 'delete_staff_id',
    fixed: false,
    checked: false,
  },
  {
    title: '员工姓名',
    width: 150,
    dataIndex: 'delete_staff__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: false,
  },
];

export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_order_used_record_list,
    columns: columns,
    slotList: defaultSlotList,
  };
};
